import { render, staticRenderFns } from "./m_pakistan_class_live.vue?vue&type=template&id=15d0fb3e&scoped=true"
import script from "./m_pakistan_class_live.vue?vue&type=script&lang=js"
export * from "./m_pakistan_class_live.vue?vue&type=script&lang=js"
import style0 from "./m_pakistan_class_live.vue?vue&type=style&index=0&id=15d0fb3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0fb3e",
  null
  
)

export default component.exports